import Index from "../../../Index";
import React, { useState } from "react";
import PagesIndex from "../../../PagesIndex";
import { useEffect } from "react";
import {
  getSubSahaylist,
  multipleDeleteSubSahay,
  subSahaylistDelete,
} from "../../../../redux/features/AddService";
import { STATUSES } from "../../../../redux/features/adminslice/AdminSlice";
import moment from "moment";
import { useSelector } from "react-redux";
import PageLoading from "../../../../components/common/pageLoading/PageLoading";
import RowPerPageDropdown from "../../../../components/common/paginationRowPerpage/RowPerPageDropdown";
import { useLocation } from "react-router-dom";

const LoanReportView = () => {
  //useselector

  //navigate and dispatch
  const navigate = PagesIndex.useNavigate();
  const location = useLocation();
  const pageData = location.state?.loanInstallment;


  return (
    <>
      <Index.Box className="page-content-box">
        <Index.Box className="barge-common-box">
          <Index.Box className="title-header">
            <Index.Box className="title-header-flex res-title-header-flex">
              <Index.Box className="plus-hidden-show-mobile">
                <Index.Box className="title-main">
                  <Index.Typography
                    variant="p"
                    component="p"
                    className="page-title"
                  >
                    Loan Report Installment
                  </Index.Typography>
                </Index.Box>
              </Index.Box>
              <Index.Box className="d-flex align-items-center res-set-search">
                {/* <PagesIndex.Search
                      className="search"
                    //   onChange={(e) => requestSearch(e.target.value)}
                    >
                      <PagesIndex.StyledInputBase
                        placeholder="Search"
                        inputProps={{ "aria-label": "search" }}
                      />
                    </PagesIndex.Search> */}
                <>
                  <Index.Box className="common-button blue-button res-blue-button desk-hidden-show">
                    <Index.Button
                      variant="contained"
                      disableRipple
                      className="no-text-decoration"
                      onClick={() =>
                        navigate("/admin/loan-report", {
                          state: { LoanDateData: location.state?.LoanDateData },
                        })
                      }
                    >
                      Back
                    </Index.Button>
                  </Index.Box>
                </>
              </Index.Box>
            </Index.Box>
          </Index.Box>

          <Index.Box className="sahay-table">
            <Index.TableContainer
              sx={{ maxHeight: 480 }}
              // component={Index.Paper}
              className="table-container  sub-type-list-container scroll-table common-table-container-custom"
            >
              <Index.Table
                stickyHeader
                aria-label="sticky table"
                className="table-design-main barge-table sub-type-list-table"
              >
                <Index.TableHead className="sub-type-list-head">
                  <Index.TableRow className="sub-type-list-tr">
                    <Index.TableCell className="sub-type-list-th">
                      S.No.
                    </Index.TableCell>
                    <Index.TableCell className="sub-type-list-th" align="left">
                      EMI Date
                    </Index.TableCell>
                    <Index.TableCell className="sub-type-list-th" align="left">
                      EMI Amount
                    </Index.TableCell>
                  </Index.TableRow>
                </Index.TableHead>
                <Index.TableBody>
                  {pageData?.length ? (
                    pageData?.map((data, index) => (
                      <Index.TableRow key={index} className="sub-type-list-tr">
                        <Index.TableCell
                          className="sub-type-list-td"
                          key={index}
                        >
                          {index + 1}
                        </Index.TableCell>
                        <Index.TableCell
                          className="sub-type-list-td"
                          key={data.Id}
                        >
                          {data?.EMIDate}
                        </Index.TableCell>
                        <Index.TableCell
                          className="sub-type-list-td"
                          align="left"
                        >
                          {" "}
                          {data?.EMIAmount}
                        </Index.TableCell>
                      </Index.TableRow>
                    ))
                  ) : (
                    <PagesIndex.NoRecordFound colSpan={12} />
                  )}

                  {pageData?.length && (
                    <Index.TableRow className="sub-type-list-tr">
                      <Index.TableCell
                        className="sub-type-list-td"
                        align="left"
                      >
                        <Index.Typography component="strong">
                          Total Amount
                        </Index.Typography>
                      </Index.TableCell>
                      <Index.TableCell
                        className="sub-type-list-td"
                        align="left"
                      ></Index.TableCell>
                      <Index.TableCell
                        className="sub-type-list-td"
                        align="left"
                      >
                        {pageData?.length > 0 &&
                          pageData?.reduce((acc, curr) => {
                            let total;
                            total = acc + curr?.EMIAmount;
                            return total;
                          }, 0)}
                      </Index.TableCell>
                    </Index.TableRow>
                  )}
                </Index.TableBody>
              </Index.Table>
            </Index.TableContainer>
          </Index.Box>
          {/* <Index.Box className="pagination-design flex-end">
                <RowPerPageDropdown
                  rowPerPage={rowPerPage}
                  setRowPerPage={setRowPerPage}
                />
                <Index.Stack spacing={2}>
                  <PagesIndex.Pagination
                    fetchData={searchedData}
                    setPageData={setPageData}
                    pageData={pageData}
                    rowPerPage={rowPerPage}
                  />
                </Index.Stack>
              </Index.Box> */}
        </Index.Box>
      </Index.Box>
      {/* <PagesIndex.DeleteModal
            deleteText={deleteText}
            deleteOpen={deleteOpen}
            handleDeleteRecord={handleDeleteRecord}
            handleDeleteClose={handleDeleteClose}
          /> */}
    </>
  );
};

export default LoanReportView;
